export default __webpack_public_path__ + "static/media/calendarIcon.64e45c34.svg";